export const ROUTE_ROOT = '/'
export const ROUTE_PARTNERS = '/partners'
export const ROUTE_PARTNERS_ALL = '/partners/all-partners'
export const ROUTE_PARTNERS_MANUAL_ADD = '/partners/json-upload'
export const ROUTE_RULES = '/home'
export const ROUTE_SIGN_IN = '/sign-in'
export const ROUTE_RULES_ALL = '/home/all-rules'
export const ROUTE_CATEGORIES = '/home/categories'
export const ROUTE_GROUP = '/home/group'
export const ROUTE_REWARDS_GRANTS = '/home/grants'
export const ROUTE_LOAN_TRANSACTION_REVIEW = '/home/loan-transaction-review'
export const ROUTE_CUSTOMERS = '/customers'
export const ROUTE_CUSTOMERS_ALL = '/customers/all-customers'
export const ROUTE_CUSTOMER_TRANSACTIONS = '/customers/:customerId/transactions'
export const ROUTE_TASKS = '/tasks'
export const ROUTE_TASKS_SCRIPT_RUNS = '/tasks/script-runs'
